module.exports = __webpack_public_path__ + "media/images/emblems/Fraubrunnen-coat_of_arms-57c3d35d16683a5c4bae3e3c6b395976.svg";